import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import '../../../../node_modules/lit-html/lit-html.js';
import '../../../../node_modules/lit-element/lit-element.js';
import { css as i } from '../../../../node_modules/@lit/reactive-element/css-tag.js';

var css_248z = i`:host{--plyr-color-main:#a70364;--plyr-video-control-color:#fff;--plyr-control-icon-size:25px;contain:content;display:block}`;

export { css_248z as default };
